
export default (totalSlides) => ({
  currentSlide: 0,

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % totalSlides
  },

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + totalSlides) % totalSlides
  },
})
